import angular from "angular";
import { FlexTableDirective } from "./flex-table.directive";
import { FlexSelectCellDirective } from "./flex-select-cell.directive";
import { FlexCellModelDirective } from "./flex-cell-model.directive";

export const FlexTableModule = angular
    .module("apex.common.directives.flexTable", [])
    .directive("apexFlexTable", FlexTableDirective)
    .directive("apexFreezeColumns", FlexTableDirective)
    .directive("apexFlexSelectCell", FlexSelectCellDirective)
    .directive("apexFlexCellModel", FlexCellModelDirective)
    .name;
